/** Upper bound on active-grid filter keys in the context snapshot — no real grid filters by more. */
export const ASSISTANT_GRID_FILTERS_MAX_ENTRIES = 50;
